import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OverlayModule} from '@angular/cdk/overlay';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import {UiPwaSpinnerService} from './ui-pwa-spinner.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OverlayModule,
    MatProgressSpinnerModule,
  ],
  providers: [UiPwaSpinnerService],
  entryComponents: [MatSpinner]
})
export class UiPwaSpinnerModule {
}
